<template>
    <div class="is-flex check-item-container">
        <div class="check-item">
            <span class="icon has-text-success" v-if="actionableItem.status === 'done'">
                <i class="far fa-check-circle"></i>
            </span>
            <span class="icon has-text-danger" v-else>
                <i class="far fa-times-circle"></i>
            </span>
            <a :href="actionableItem.actionUrl ?? '#'">
                <span> {{ translate(actionableItem.actionName) }}<template v-if="actionableItem.actionValue">:</template> </span>
                <template v-if="actionableItem.actionValue">
                    {{ translate(actionableItem.actionValue, true) }}
                </template>
            </a>

            <a v-if="actionableItem.dismissible" class="has-text-danger" @click="dismissActionableItem">
                <span class="icon">
                    <i class="fa fa-times"></i>
                </span>
            </a>

            <a target="_blank" v-if="actionableItem.helpCenterUrl" :href="actionableItem.helpCenterUrl">
                <span class="icon">
                    <i class="fas fa-question-circle"></i>
                </span>
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ActionableItem, adminEventSummaryApi } from "../Api/adminEventSummaryApi";
    import { translate } from "../Common/translations";
    import { ref } from "vue";
    import { handleError } from "../Common/errorHandler";
    import { eventBus, REFRESH_SUMMARY } from "./eventBus";

    const props = defineProps<{ eventId: number; actionableItem: ActionableItem }>();

    const dismissInProgress = ref(false);

    function dismissActionableItem() {
        dismissInProgress.value = true;
        return adminEventSummaryApi
            .dismissActionableItem(props.eventId, props.actionableItem.actionName)
            .then(() => {
                eventBus.$emit(REFRESH_SUMMARY);
            })
            .catch(handleError)
            .finally(() => {
                dismissInProgress.value = false;
            });
    }
</script>

<style scoped></style>
